import { CSSProperties } from 'react';

import classnames from 'classnames/bind';

import styles from './index.module.less';

const cx = classnames.bind(styles);

type TitleTextProps = {
  text: string;
  className?: string;
  style?: CSSProperties;
};

export function TitleText(props: TitleTextProps) {
  const { text, className, style } = props;
  return (
    <p className={cx('recommend-title-text', className)} style={style}>
      {text}
    </p>
  );
}
